import { render, staticRenderFns } from "./InformacionPunto.vue?vue&type=template&id=db63934a&scoped=true"
import script from "./InformacionPunto.vue?vue&type=script&lang=js"
export * from "./InformacionPunto.vue?vue&type=script&lang=js"
import style0 from "./InformacionPunto.vue?vue&type=style&index=0&id=db63934a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db63934a",
  null
  
)

export default component.exports